<template>
  <div class="mb-2">
    <button
      :id="`button_stripe_${options.stripe.type}`"
      :disabled="buttonDisabled"
      @click="pay"
      class="btn btn-lg btn-primary"
    >
      {{ translations[`pay_with_${options.stripe.type}`] }}
    </button>
    <form ref="form" :action="options.url" method="POST">
      <input :value="sourceId" type="hidden" name="source" />
      <input :value="csrfToken" type="hidden" name="authenticity_token" />
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CheckoutPaymentsStripeGenericPayment",
  props: {
    translations: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      staticOpions: {
        currency: "eur",
      },
      sourceId: null,
      buttonDisabled: this.disabled,
    };
  },
  computed: {
    ...mapGetters({
      csrfToken: "getCsrfToken",
      Stripe: "checkoutPayment/globalStripe",
    }),
  },
  methods: {
    ...mapActions({
      fetchCsrfToken: "fetchCsrfToken",
    }),
    async pay() {
      this.buttonDisabled = true;
      await this.fetchCsrfToken();
      this.Stripe.createSource({
        ...this.options.stripe,
        ...this.staticOpions,
      }).then(result => {
        if (result.source) {
          this.sourceId = result.source.id;
          this.$nextTick().then(() => this.$refs.form.submit());
        } else {
          this.buttonDisabled = false;
        }
      });
    },
  },
};
</script>
